import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createMRTColumnHelper } from "material-react-table";
import CustomTable from "../../components/customTable/CustomTable";
import { Button, IconButton, Tooltip } from "@mui/material";
import { toast } from "react-toastify";
import { ContentCopy } from "@mui/icons-material"; // Import the copy icon from MUI

// import FindTotalCommission from "../partnerReportCard/FindTotalCommission";
import { partnerInvoiceApi } from "../../app/slices/partnerInvoice/partnerInvoiceSlice";
import { viewInvoiceApi } from "../../app/slices/partnerInvoice/viewInvoiceSlice";
import PdfViewerModal from "./PdfViewerModal";
import ShowTransactionModal from "./ShowTransactionModal";
import { partnerTransactionApi } from "../../app/slices/partnerInvoice/partnerTransactionSlice";
import Swal from "sweetalert2";
import { updatePaymentApi } from "../../app/slices/partnerInvoice/updatePaymentSlice";

export default function PartnerInvoice() {
  const dispatch = useDispatch();
  const [pdfUrl, setPdfUrl] = useState(null);
  const [open, setOpen] = useState(false);
  const [_id, set_id] = useState("");

  const [openTransaction, setOpenTransaction] = useState(false);
  const [showTransactionsData, setshowTransactionsData] = useState([]);

  const [monthYear, setMonthYear] = useState({ month: "", year: "" });
  const roleResponse = useSelector((state) => state.login.login.role);
  useEffect(() => {
    dispatch(partnerInvoiceApi(monthYear));
  }, [dispatch, monthYear]);
  const sliceResponse = useSelector(
    (state) => state.partnerInvoice.partnerInvoice.data,
  );
  const stateLoading = useSelector((state) => state.partnerInvoice.loading);
  const [paymentStauts, setpaymentStauts] = useState("");
  // console.log("paymentStauts: ", paymentStauts);

  const columnHelper = createMRTColumnHelper();
  const columns = [
    columnHelper.accessor("_id", {
      header: "ID",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?._id);
          toast.success("copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?._id}>
            <IconButton onClick={handleCopy}>
              <ContentCopy />
            </IconButton>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("name", {
      header: "Name",
      size: 30,
      Cell: (cell) => cell.row.original?.name,
    }),
    columnHelper.accessor("username", {
      header: "Username",
      size: 30,
      Cell: (cell) => cell.row.original?.username,
    }),
    columnHelper.accessor("totalCommission", {
      header: "Total Commission",
      size: 30,
      Cell: (cell) => cell.row.original?.totalCommission,
    }),
    columnHelper.accessor("commissionPer", {
      header: "Partner Commission",
      size: 30,
      Cell: (cell) => cell.row.original?.commissionPer,
    }),
    columnHelper.accessor("totalPreTaxAmount", {
      header: "Total PreTaxAmount",
      size: 30,
      Cell: (cell) => cell.row.original?.totalPreTaxAmount,
    }),
    columnHelper.accessor("isBlocked", {
      header: "Blocked",
      size: 30,
      Cell: (cell) => (cell.row.original?.isBlocked == "false" ? "Yes" : "No"),
    }),
    columnHelper.accessor("status", {
      header: "status",
      size: 30,
      Cell: (cell) => cell.row.original?.status,
    }),
    columnHelper.accessor("showtransection", {
      header: "Show Transection",
      size: 30,
      Cell: ({ cell }) => {
        const handleShowTransection = async () => {
          const response = await dispatch(
            partnerTransactionApi({
              _id: cell.row.original._id,
              month: monthYear.month,
              year: monthYear.year,
            }),
          );
          if (response.meta.requestStatus === "fulfilled") {
            if (response.payload.data.allTransactions?.length == 0) {
              Swal.fire({
                // title: "error",
                text: "No transaction found",
                // icon: "error",
                timer: 5000,
                showConfirmButton: false,
              });
            } else {
              setOpenTransaction(true);
              setshowTransactionsData(response.payload.data.allTransactions);
              // console.log(
              //   "response.payload.data: of show transaction ",
              //   response.payload.data
              // );
            }
          }
        };
        return (
          <Button
            onClick={handleShowTransection}
            // variant="contained"
            sx={{
              backgroundColor: "#4a2a7d",
              color: "white !important",
            }}
          >
            Show Transactions
          </Button>
        );
      },
    }),
    columnHelper.accessor("sendInvoice", {
      header: "Send Invoice",
      size: 30,
      Cell: ({ cell }) => {
        const handleViewInvoice = async () => {
          setpaymentStauts(cell.row.original?.status);
          try {
            const response = await dispatch(
              viewInvoiceApi({
                username: cell.row.original.username,
                commission: cell.row.original.totalCommission,
                is_deleted: cell.row.original.is_deleted,
                isBlocked: cell.row.original.isBlocked,
                name: cell.row.original.name,
                totalCommission: cell.row.original.totalCommission,
                totalPreTaxAmount: cell.row.original.totalPreTaxAmount,
                totalSilverPreTaxAmount:
                  cell.row.original.totalSilverPreTaxAmount,
                totalGoldPreTaxAmount: cell.row.original.totalGoldPreTaxAmount,
                totalSilverQuantity: cell.row.original.totalSilverQuantity,
                totalGoldQuantity: cell.row.original.totalGoldQuantity,
                totalGoldTotalAmount: cell.row.original.totalGoldTotalAmount,
                totalSilverTotalAmount:
                  cell.row.original.totalSilverTotalAmount,
                totalGoldGst: cell.row.original.totalGoldGst,
                totalSilverGst: cell.row.original.totalSilverGst,
                totalGoldCommission: cell.row.original.totalGoldCommission,
                totalSilverCommission: cell.row.original.totalSilverCommission,
                month: monthYear.month,
                year: monthYear.year,
              }),
            );

            // console.log("response:::::::::::::::::::", response);
            if (response.meta.requestStatus === "fulfilled") {
              if (response.payload.message == "No Transaction found") {
                Swal.fire({
                  // title: "No transaction found",
                  text: "No transaction found",
                  // icon: "info",
                  timer: 5000,
                  showConfirmButton: false,
                });
              } else {
                setOpen(true);
                setPdfUrl(response.payload?.data?.pdfLink);
                set_id(response.payload?.data?._id);
              }
            }
          } catch (error) {
            console.log("error: ", error);
          }
        };
        return (
          <Button
            onClick={handleViewInvoice}
            sx={{
              backgroundColor: "#4a2a7d",
              color: "white !important",
            }}
          >
            View Invoice{" "}
          </Button>
        );
      },
    }),
    columnHelper.accessor("updatePaymentstatus", {
      header: "Update Payment Status",
      size: 300,
      Cell: ({ cell }) => {
        const handlePaymentStatus = async () => {
          const result = await Swal.fire({
            title: "Are you sure?",
            text: "Do you want to update payment status?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes",
            cancelButtonText: "No",
            customClass: {
              popup: "custom-swal-popup",
            },
            willOpen: () => {
              const popup = document.querySelector(".custom-swal-popup");
              if (popup) {
                popup.style.zIndex = 4000;
              }
            },
          });

          if (result.isConfirmed) {
            const response = await dispatch(
              updatePaymentApi({
                username: cell.row.original.username,
                month: monthYear.month,
                year: monthYear.year,
              }),
            );
            console.log("response: of update payment ", response);
            if (response.meta.requestStatus === "fulfilled") {
              console.log("response.payload: ", response.payload);
              dispatch(partnerInvoiceApi(monthYear));
              // Swal.fire('Send', 'Email send Successfully .', 'success');
              Swal.fire({
                title: response.payload.error == true ? "error" : "success",
                // text: 'Payment Updated successfully.',
                text: response.payload.message,
                icon: response.payload.error == true ? "error" : "success",
                timer: 5000, // Auto close after 3 seconds (3000 milliseconds)
                showConfirmButton:
                  response.payload.error == true ? true : false, // Hide the "OK" button
              });
            }
          } else {
            Swal.fire("Cancelled", "The action was cancelled.", "error");
          }
        };
        return (
          <Button
            onClick={handlePaymentStatus}
            // variant="contained"
            disabled={cell.row.original.status == "paid" ? true : false}
            sx={{
              backgroundColor:
                cell.row.original.status == "paid" ? "#f45f5f" : "#4a2a7d",
              color: "white !important",
            }}
          >
            {cell.row.original.status == "paid"
              ? "Payment Already Paid"
              : "Update Payment Status"}
          </Button>
        );
      },
    }),
  ];

  const handleMonthYearChange = (value) => {
    setMonthYear(value);
    // console.log("Selected Month and Year:", value);
  };

  return (
    <>
      {/*  */}
      {/* {roleResponse?.PartnerInvoice?.update === 1 && <FindTotalCommission sliceResponse={sliceResponse} />} */}
      <CustomTable
        columns={columns}
        data={sliceResponse}
        showMonthYearPicker={true}
        onMonthYearChange={handleMonthYearChange}
        loading={stateLoading}
        permissionKey="PartnerInvoice"
      />

      <PdfViewerModal
        pdfUrl={pdfUrl}
        open={open}
        onClose={() => setOpen(false)}
        _id={_id}
        paymentStauts={paymentStauts}
      />
      <ShowTransactionModal
        openTransaction={openTransaction}
        onClose={() => setOpenTransaction(false)}
        showTransactionsData={showTransactionsData}
      />
    </>
  );
}
